module.exports = __webpack_public_path__ + "static/03-7676340fac4e80fc78b33594cf8433a2.jpg";